module.exports = __webpack_public_path__ + "static/media/bg.272dbf4b.jpg";